export enum GlPurposeEnum {
  DOWN_PAYMENT = 'DOWN_PAYMENT',
  REVENUE = 'REVENUE',
  SALES_DISCOUNT = 'SALES_DISCOUNT',
  SALES_SKONTO = 'SALES_SKONTO',
  TRADE_PAYABLES = 'TRADE_PAYABLES',
  TRADE_RECEIVABLES = 'TRADE_RECEIVABLES',
  VAT_SALES = 'VAT_SALES',
  VAT_PURCHASES = 'VAT_PURCHASES',
  WRITE_OFF_DEFAULT = 'WRITE_OFF_DEFAULT',
  PURCHASE_FOR_RESALE = 'PURCHASE_FOR_RESALE',
  LOW_VALUE_ASSET_PURCHASE = 'LOW_VALUE_ASSET_PURCHASE',
  LOW_VALUE_ASSET_IMMEDIATE_EXPENSING = 'LOW_VALUE_ASSET_IMMEDIATE_EXPENSING',
  BANK_BALANCE = 'BANK_BALANCE',
  CASH_BALANCE = 'CASH_BALANCE',
  FIXED_ASSET_DEPRECIATION = 'FIXED_ASSET_DEPRECIATION',
  PRODUCT_TYPE_EXPENSES = 'PRODUCT_TYPE_EXPENSES',
  PURCHASE_SKONTO = 'PURCHASE_SKONTO',
  PURCHASE_ROUNDING_CORRECTION = 'PURCHASE_ROUNDING_CORRECTION',
  PRIVATE_PAYMENT = 'PRIVATE_PAYMENT',
}
